import httpClient, { handleAPIError } from './httpClient'
import { Milestone, APIResponse } from '../types'
import { MockMilestoneService } from '../mock'
import { API_ENDPOINTS } from '../utils/apiEndpoints'
import { WHOLE_USE_MOCK } from './api'

export interface MilestoneStatusUpdateRequest {
  milestoneId: string
  status: string
  actualStartTime?: Date
  actualEndTime?: Date
  notes?: string
}


class MilestoneService {
  private static useMock: boolean = true;

  // Get milestones for a plan
  async getMilestones(Id: string): Promise<APIResponse<Milestone[]>> {
    try {
      // Use mock service for development
      if (MilestoneService.useMock && WHOLE_USE_MOCK) {
        return await MockMilestoneService.getMilestonesByPlan({ Id })
      }
      
      
      // Uncomment below for production API calls
      const response = await httpClient.get<APIResponse<Milestone[]>>(API_ENDPOINTS.PLAN.MILESTONES_LIST + `?planId=${Id}`);
      return response.data
    } catch (error) {
      throw handleAPIError(error)
    }
  }

  // Update milestone status
  async updateMilestoneStatus(params: MilestoneStatusUpdateRequest): Promise<APIResponse<Milestone>> {
    try {
      const response = await httpClient.post<APIResponse<Milestone>>(API_ENDPOINTS.PLAN.MILESTONES_STATUS_UPDATE, params);
      return response.data
    } catch (error) {
      throw handleAPIError(error)
    }
  }
}

export const milestoneService = new MilestoneService()